import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import defaultComponentData from "./../ricos-schema/legacy/statics/divider.defaults.json.js";
import { INSERT_PLUGIN_BUTTONS, TOOLBARS } from "./../editor-common/index.js";
import { INSERT_DIVIDER_BUTTON } from "./data-hooks.js";
import InsertPluginIcon from "./icons/InsertPluginIcon.js";
import { DIVIDER_TYPE } from "./types.js";
const toolbarsToAddIn = [
  TOOLBARS.MOBILE,
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE
];
const getAddButtons = (_config, _services) => {
  return [
    {
      id: Node_Type.DIVIDER,
      icon: InsertPluginIcon,
      label: INSERT_PLUGIN_BUTTONS.DIVIDER,
      dataHook: INSERT_DIVIDER_BUTTON,
      tooltip: "DividerPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: ({ publicCommands }) => {
        publicCommands.insertBlockWithBlankLines(DIVIDER_TYPE, defaultComponentData);
        return true;
      },
      menuConfig: {
        tags: "Divider_plugin_search_tags"
      }
    }
  ];
};
export {
  getAddButtons,
  toolbarsToAddIn
};
//# sourceMappingURL=getAddButtons.js.map
